import { apiClient } from '../../../api/client'
import { downloadXlsx } from '../../../lib/download'
import type { MeetingDecisionType, MeetingDecisionTypeUpsert, PagedResponse } from '../types'

const BASE = '/management/meeting-decision-types'

/** Silinmemiş kayıtların (sıralı) listesi. Lookup ölçeği küçük → tümünü tek sayfada çekeriz (size=200). */
export async function getMeetingDecisionTypes(): Promise<PagedResponse<MeetingDecisionType>> {
  const { data } = await apiClient.get<PagedResponse<MeetingDecisionType>>(BASE, {
    params: { page: 0, size: 200 },
  })
  return data
}

/** Kaydı güncelle (ad; optimistic lock modDate zorunlu). */
export async function updateMeetingDecisionType(
  id: number,
  body: MeetingDecisionTypeUpsert,
): Promise<MeetingDecisionType> {
  const { data } = await apiClient.put<MeetingDecisionType>(`${BASE}/${id}`, body)
  return data
}

/** Yeniden sıralama — görünen sıranın tamamını (orderedIds) gönderir; SORT_INDEX 1..N yeniden yazılır. */
export async function reorderMeetingDecisionTypes(orderedIds: number[]): Promise<void> {
  await apiClient.put(`${BASE}/reorder`, { orderedIds })
}

/**
 * Karar türü listesini Excel (.xlsx) olarak indirir.
 *
 * Liste ucuyla aynı filtreler; sunucu **tüm** filtreli kayıtları döndürür (sayfalama yok). İndirme
 * mekaniği ve dosya adı ortak {@link downloadXlsx} yardımcısındadır (boş filtreler gönderilmez; ad
 * sunucunun Content-Disposition'ından okunur).
 */
export async function exportMeetingDecisionTypes(): Promise<void> {
  await downloadXlsx(`${BASE}/export`, {}, 'karar-turleri.xlsx')
}
